<script>
  import { _ } from 'svelte-i18n';
</script>

<div class="py-10 text-xs md:text-sm">
  <div
    id="footer"
    class="flex items-center justify-center px-5 text-center leading-relaxed"
  >
    <div class="max-w-2xl">
      <p class="text-gray-500">
        {$_('components.footer.copyright', {
          default: 'Copyright {year} Button, Inc. All rights reserved.',
          values: {
            year: new Date().getFullYear(),
          },
        })}
      </p>
      <p class="mt-2 font-light text-gray-400">
        {$_('components.footer.tospp.body-', {
          default:
            "This proprietary Button technology (patents granted and pending) is provided pursuant to, and by using this technology you hereby agree to, Button's ",
        })}
        <a
          class="text-buttonBlue/70"
          href="https://www.usebutton.com/support/terms-of-service"
          target="_blank"
          >{$_('components.footer.tospp.tos', {
            default: 'Terms of Service',
          })}</a
        >
        {$_('components.footer.tospp.-and-', {
          default: ' and ',
        })}
        <a
          class="text-buttonBlue/70"
          href="https://www.usebutton.com/support/privacy-policy"
          target="_blank"
        >
          {$_('components.footer.tospp.pp', {
            default: 'Privacy Policy',
          })}
        </a>.
      </p>
    </div>
  </div>
</div>
